import { cloneElement } from 'react'

import { FormFieldConfig } from '../../../../features/ui-config'
import { getConfigTranslation } from '../../../helper/getConfigTranslation'

export function createComponent(
  config: FormFieldConfig,
  component: JSX.Element,
) {
  const newProps: { [key: string]: any } = {
    // If field is in code disabled make it disabled otherwise use the config
    disabled: component.props.disabled || config?.readonly,
    placeholder: getConfigTranslation(config?.placeholder),
  }

  // Only add the maxFileSize and accept properties if the component is a FileUpload
  if (component.type.displayName === 'FileUpload') {
    newProps.maxFileSize =
      config.validation?.maxFileSize !== undefined
        ? config.validation.maxFileSize
        : component.props.maxFileSize
    newProps.accept =
      config.validation?.accept !== undefined
        ? config.validation?.accept
        : component.props.accept
  }

  return cloneElement(component, newProps)
}
